import {
  IActivityCategory,
  IAPIActivityCategoryAttributes,
} from '../interface/IActivityCategory'

export const activityCategoriesTransformer = (
  apiAttributes: IAPIActivityCategoryAttributes
): IActivityCategory => ({
  id: apiAttributes.id,
  name: apiAttributes.name,
  order: apiAttributes.order,
  image: apiAttributes.image,
})
